<template>
  <div class="edit-purchase-plan">
    <common-header />
    <div class="width-1260">
      <el-breadcrumb>
        <el-breadcrumb-item :to="{ path: '/' }"
          >平方区域联采</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/mineProject' }"
          >我的联采项目</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/purchasePlanList' }"
          >采购计划</el-breadcrumb-item
        >
        <el-breadcrumb-item>采购计划详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="white-container">
        <div class="form-container">
          <el-form
            ref="purchasePlanRef"
            :model="newPurchasePlan"
            :rules="pruchasePlanRules"
            label-width="86px"
          >
            <div class="d-flex-wrap d-flex-space-b">
              <el-form-item label="计划名称:" prop="planName">
                <el-input
                  :disabled="pruchasePlanEditDisable"
                  :style="{ width: '480px' }"
                  v-model="newPurchasePlan.planName"
                  placeholder="请输入计划名称"
                />
              </el-form-item>
              <el-form-item label="计划编号:">
                <el-input
                  disabled
                  :style="{ width: '480px' }"
                  v-model="newPurchasePlan.planNo"
                />
              </el-form-item>
              <el-form-item label="项目地址:" required>
                <el-form-item prop="citySelect">
                  <el-cascader
                    :disabled="pruchasePlanEditDisable"
                    v-model="newPurchasePlan.citySelect"
                    :style="{ width: '210px' }"
                    clearable
                    placeholder="省市"
                    :options="areaDic"
                    @change="changeCity"
                  />
                </el-form-item>
                <el-form-item prop="address">
                  <el-input
                    :disabled="pruchasePlanEditDisable"
                    :style="{ width: '270px' }"
                    v-model="newPurchasePlan.address"
                    placeholder="详细地址"
                  />
                </el-form-item>
              </el-form-item>
              <el-form-item label="材料类型:" prop="categorySelect">
                <el-cascader
                  :disabled="pruchasePlanEditDisable"
                  ref="categoryRef"
                  v-model="newPurchasePlan.categorySelect"
                  :style="{ width: '480px' }"
                  clearable
                  placeholder="请选择材料类型"
                  :options="categoryDic"
                  :props="{ value: 'id', label: 'name' }"
                  @change="changeCategory"
                />
              </el-form-item>
              <el-form-item label="备注:">
                <el-input
                  :disabled="pruchasePlanEditDisable"
                  type="textarea"
                  placeholder="请输入备注"
                  :rows="5"
                  :style="{ width: '1116px' }"
                  v-model="newPurchasePlan.remarks"
                />
              </el-form-item>
            </div>
          </el-form>
          <div class="text-align-end" v-if="!pruchasePlanEditDisable">
            <el-button
              type="primary"
              @click="submitPurchasePlan(purchasePlanRef)"
              >保存
            </el-button>
            <el-button @click="backToPlanList">取消</el-button>
          </div>
        </div>
        <div
          class="d-flex-space-b margin-b-12"
          :class="pruchasePlanEditDisable ? 'd-flex-row-reverse' : ''"
        >
          <el-button
            type="primary"
            @click="addTableLine"
            class="margin-l-66"
            v-if="!pruchasePlanEditDisable"
            :disabled="editing"
            >新增材料</el-button
          >
          <div class="d-flex">
            <el-button class="margin-r-10" @click="handleDownloadFile">
              <el-icon class="icon icon-xiazai3"></el-icon>
              下载材料清单模板</el-button
            >
            <el-upload
              v-model:file-list="fileList"
              class="upload-demo"
              :action="uploadPurchaseMaterialUrl"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              :on-exceed="handleExceed"
              :with-credentials="true"
              :show-file-list="false"
              accept=".xlsx, .xls"
              :data="{ m2PurchasePlanId: purchasePlanId }"
              v-if="!pruchasePlanEditDisable"
              :disabled="editing"
            >
              <el-button :disabled="editing">
                <el-icon class="icon icon-shangchuan2"></el-icon>导入材料清单
              </el-button>
            </el-upload>
          </div>
        </div>
        <el-form ref="materialFormRef" :model="newMaterial" :rules="formRule">
          <el-table
            :data="tableData"
            :border="parentBorder"
            :header-cell-style="{
              backgroundColor: '#F2F3F5',
              color: '#1D2129',
            }"
            style="width: 100%"
            tooltip-effect="light"
          >
            <el-table-column
              label="序号"
              width="80"
              align="center"
              show-overflow-tooltip
            >
              <template #default="scope">
                <span v-if="scope.row.id">{{ scope.$index + 1 }} </span>
              </template>
            </el-table-column>
            <el-table-column
              label="材料名称"
              align="center"
              show-overflow-tooltip
            >
              <template #default="scope">
                <el-form-item prop="materialName" v-if="scope.row.edit">
                  <el-input
                    v-model="newMaterial.materialName"
                    placeholder="材料名称"
                  />
                </el-form-item>
                <span v-else>{{ scope.row.materialName }} </span>
              </template>
            </el-table-column>
            <el-table-column
              label="规格型号"
              align="center"
              show-overflow-tooltip
            >
              <template #default="scope">
                <el-form-item prop="spec" v-if="scope.row.edit">
                  <el-input v-model="newMaterial.spec" placeholder="规格型号" />
                </el-form-item>
                <span v-else>{{ scope.row.spec }} </span>
              </template>
            </el-table-column>
            <el-table-column
              label="计划采购数量"
              align="center"
              show-overflow-tooltip
            >
              <template #default="scope">
                <el-form-item prop="purchaseCount" v-if="scope.row.edit">
                  <el-input
                    v-model="newMaterial.purchaseCount"
                    placeholder="计划采购数量"
                  />
                </el-form-item>
                <span v-else>{{ scope.row.purchaseCount }} </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="unit"
              label="单位"
              align="center"
              show-overflow-tooltip
            >
              <template #default="scope">
                <el-form-item prop="unit" v-if="scope.row.edit">
                  <el-input
                    v-if="scope.row.edit"
                    v-model="newMaterial.unit"
                    placeholder="单位"
                  />
                </el-form-item>
                <span v-else>{{ scope.row.unit }} </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="materialDesc"
              label="材料说明"
              align="center"
              show-overflow-tooltip
            >
              <template #default="scope">
                <el-form-item prop="materialDesc" v-if="scope.row.edit">
                  <el-input
                    v-model="newMaterial.materialDesc"
                    placeholder="材料说明"
                  />
                </el-form-item>
                <span v-else>{{ scope.row.materialDesc }} </span>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              align="center"
              show-overflow-tooltip
              v-if="!pruchasePlanEditDisable"
            >
              <template #default="scope">
                <template v-if="scope.row.edit">
                  <span
                    :key="scope.row"
                    class="font-c-175eff cursor-pointer margin-r-10"
                    @click="saveM2MaterialDetails"
                    >保存
                  </span>
                  <span
                    class="font-c-175eff cursor-pointer"
                    @click="cancelAddLine(scope.$index)"
                    >取消</span
                  >
                </template>
                <template v-else>
                  <span
                    @click="addTableLine(scope)"
                    class="font-c-175eff cursor-pointer margin-r-10"
                    >编辑
                  </span>
                  <span
                    class="font-c-175eff cursor-pointer"
                    @click="deleteM2MaterialDetails(scope.row.id)"
                    >删除</span
                  >
                </template>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </div>
    </div>
    <el-backtop :right="100" :bottom="100" />
    <common-footer />
    <el-dialog
      v-model="qrCodeVisible"
      @close="closeQrcodeDialog"
      title="采购计划保存成功"
      width="772px"
    >
      <qr-code-modal-content
        v-if="qrCodeVisible"
        :type="3"
        qrCodeUrl="https://gcj-statics.oss-cn-beijing.aliyuncs.com/joint/web/lc-supplier-price-success-qrcode.jpg"
      />
    </el-dialog>
  </div>
</template>

<script>
module.exports = require("./index.js");
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
